module.exports = __webpack_public_path__ + "static/media/ic-live-tv.924a0ba4.svg";